import React, { useState, useEffect } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import LockResetIcon from '@mui/icons-material/LockReset';
import BlockIcon from '@mui/icons-material/Block';

import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  Menu,
  MenuItem,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Alert,
  CircularProgress,
  Snackbar,
  Skeleton,
  Tooltip,

} from '@mui/material';
import  MuiAlert from '@mui/material/Alert';
import {
  Add as AddIcon,
  MoreVert as MoreVertIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  PersonAdd as PersonAddIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { getUsersAPI, userStatusAction } from '../../Action/api';
import { format } from 'date-fns';
import AddUserDialog from './add';
import EditUserDialog from './edit';
import ResetPasswordDialog from './resetPassword';
import { menuListData } from './menuListData';


// Remove the forwardRef Alert declaration and just keep these imports

export const Users = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [openResetDialog, setOpenResetDialog] = useState(false);
    const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [statusChangeUser, setStatusChangeUser] = useState(null);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false); // Add a new state for button loading

  useEffect(() => {
    fetchUsers();
  }, []);

    const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await getUsersAPI();
      if (response.data && response.data.status) {
        setUsers(response.data.users);
      } else {
        setError('Failed to fetch users');
      }
    } catch (error) {
      setError('Error loading users');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get permission status
  const getPermissionStatus = (menuList, menuId) => {
    const menu = menuList.find(m => m.menuId === menuId);
    return menu?.permission === 'yes';
  };


  // Sample users data
  // const users = [
  //   {
  //     id: 1,
  //     name: 'Alex Johnson',
  //     email: 'alex.j@company.com',
  //     role: 'Admin',
  //     department: 'IT',
  //     status: 'Active',
  //     lastLogin: '2025-08-21 09:30 AM',
  //     avatar: 'AJ',
  //   },
  //   {
  //     id: 2,
  //     name: 'Sarah Miller',
  //     email: 's.miller@company.com',
  //     role: 'User',
  //     department: 'HR',
  //     status: 'Inactive',
  //     lastLogin: '2025-08-20 04:15 PM',
  //     avatar: 'SM',
  //   },
  //   // Add more sample users as needed
  // ];

  const handleMenuOpen = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  // Update the handleMenuClose function
  const handleMenuClose = () => {
    setAnchorEl(null);
    // Add a small delay before clearing the selected user
    setTimeout(() => {
      setSelectedUser(null);
    }, 100);
  };

  const handleAddUserClick = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleAddUserSuccess = (userName, userType) => {
    setSnackbar({
      open: true,
      message: `Successfully added ${userName} as a new ${userType.toLowerCase()}`,
      severity: 'success'
    });
    fetchUsers(); // Refresh the users list
  };

  const handleEditClick = (user) => {
    setSelectedUserData(user);
    setOpenEditDialog(true);
    handleMenuClose();
  };

   const handleResetPasswordClick = (user) => {
      console.log('Reset password clicked for user:', user); // Add debug log
  if (!user?.userId) {
    console.error('Invalid user data:', user);
    return;
  }
  setSelectedUser(user);
  setOpenResetDialog(true);
  handleMenuClose();
  };

  const handleEditSuccess = (userName) => {
    setSnackbar({
      open: true,
      message: `Successfully updated ${userName}`,
      severity: 'success'
    });
    fetchUsers(); // Refresh the users list
  };

  const handleResetSuccess = (userName) => {
    console.log('Password reset successful for:', userName);
    setSnackbar({
      open: true,
      message: `Successfully reset password for ${userName}`,
      severity: 'success'
    });
    setOpenResetDialog(false);
  };

  // Alternative approach - you can also use useEffect to handle the dialog opening
// useEffect(() => {
//   if (selectedUser) {
//     setOpenResetDialog(true);
//   }
// }, [selectedUser]);

 useEffect(() => {
    if (selectedUser && openResetDialog) {
      console.log('Dialog should open for user:', selectedUser); // Add this for debugging
    }
  }, [selectedUser, openResetDialog]);
 
  const handleStatusChange = (user) => {
    setStatusChangeUser(user);
    setOpenConfirmDialog(true);
    handleMenuClose();
  };

  const handleStatusChangeConfirm = async () => {
    setIsStatusUpdating(true); // Start loading
    try {
      const newStatus = statusChangeUser.userStatus === 'Active' ? 'Inactive' : 'Active';
      const response = await userStatusAction({
        userId: statusChangeUser.userId,
        userStatus: newStatus
      });

      if (response && response.status) {
        setSnackbar({
          open: true,
          message: `Successfully ${newStatus === 'Active' ? 'activated' : 'deactivated'} ${statusChangeUser.staffFullName}`,
          severity: 'success'
        });
        fetchUsers(); // Refresh the users list
      } else {
        setSnackbar({
          open: true,
          message: `Failed to update user status`,
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Error updating user status:', error);
      setSnackbar({
        open: true,
        message: 'An error occurred while updating user status',
        severity: 'error'
      });
    } finally {
      setIsStatusUpdating(false); // Stop loading
      setOpenConfirmDialog(false);
      setStatusChangeUser(null);
    }
  };

  return (
    <Box sx={{ py: 3, bgcolor: '#f8fafc', minHeight: '100vh' }}>
      <Container maxWidth="xl">
        {/* Header Section */}
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>
              Users Management
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage user access and permissions
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<PersonAddIcon />}
            onClick={handleAddUserClick}
            sx={{
              bgcolor: '#4f46e5',
              '&:hover': { bgcolor: '#4338ca' },
              borderRadius: 2,
              px: 3,
            }}
          >
            Add New User
          </Button>
        </Box>

        {/* Search and Filter Section */}
        <Paper sx={{ p: 2, mb: 4, borderRadius: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                placeholder="Search users..."
                InputProps={{
                  startAdornment: <SearchIcon sx={{ color: '#94a3b8', mr: 1 }} />,
                }}
                sx={{ bgcolor: '#fff' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                <Button
                  variant="outlined"
                  startIcon={<FilterListIcon />}
                  sx={{ borderColor: '#e2e8f0', color: '#64748b' }}
                >
                  Filter
                </Button>
                <Button
                  variant="outlined"
                  sx={{ borderColor: '#e2e8f0', color: '#64748b' }}
                >
                  Export Users
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* Users Table */}
                {/* Users Table */}
        <TableContainer 
          component={Paper} 
          sx={{ 
            mt: 3, 
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                <TableCell sx={{ fontWeight: 600 }}>User</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Role</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Permissions</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell> {/* Add this line */}
                <TableCell sx={{ fontWeight: 600 }}>Created Date</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(() => {
    if (loading) {
      return [...Array(4)].map((_, index) => (
        <TableRow key={index}>
          {[...Array(6)].map((_, cellIndex) => ( // Update from 5 to 6
            <TableCell key={cellIndex}>
              <Skeleton animation="wave" />
            </TableCell>
          ))}
        </TableRow>
      ));
    }

    if (error) {
      return (
        <TableRow>
          <TableCell colSpan={6} align="center" sx={{ py: 3 }}> {/* Update from 5 to 6 */}
            <Typography color="error">{error}</Typography>
          </TableCell>
        </TableRow>
      );
    }

    return users.map((user) => (
      <TableRow 
        key={user.userId}
        sx={{ '&:hover': { bgcolor: '#f8fafc' } }}
      >
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: '#4f46e5' }}>
              {user.staffFullName?.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                {user.staffFullName}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {user.userId}
              </Typography>
            </Box>
          </Box>
        </TableCell>
        <TableCell>
          <Chip 
            label={user.roleName || 'User'}
            size="small"
            sx={{
              bgcolor: (user.roleName === 'Admin') ? '#fee2e2' : '#f0fdf4',
              color: (user.roleName === 'Admin') ? '#dc2626' : '#059669',
              fontWeight: 500,
            }}
          />
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Tooltip title="Dashboard Access">
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1,
                backgroundColor: getPermissionStatus(user.menuList, 'MENU-001') ? '#f0fdf4' : '#fef2f2',
                padding: '4px 8px',
                borderRadius: '6px',
                border: '1px solid',
                borderColor: getPermissionStatus(user.menuList, 'MENU-001') ? '#86efac' : '#fecaca',
              }}>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    fontWeight: 600,
                    color: getPermissionStatus(user.menuList, 'MENU-001') ? '#15803d' : '#dc2626',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <span>Dashboard</span>
                  {getPermissionStatus(user.menuList, 'MENU-001') ? (
                    <CheckCircleIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <CloseIcon sx={{ fontSize: 16 }} />
                  )}
                </Typography>
              </Box>
            </Tooltip>

            <Tooltip title="Sales Board Access">
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1,
                backgroundColor: getPermissionStatus(user.menuList, 'MENU-002') ? '#f0fdf4' : '#fef2f2',
                padding: '4px 8px',
                borderRadius: '6px',
                border: '1px solid',
                borderColor: getPermissionStatus(user.menuList, 'MENU-002') ? '#86efac' : '#fecaca',
              }}>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    fontWeight: 600,
                    color: getPermissionStatus(user.menuList, 'MENU-002') ? '#15803d' : '#dc2626',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <span>Sales Board</span>
                  {getPermissionStatus(user.menuList, 'MENU-002') ? (
                    <CheckCircleIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <CloseIcon sx={{ fontSize: 16 }} />
                  )}
                </Typography>
              </Box>
            </Tooltip>

            <Tooltip title="Users Access">
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1,
                backgroundColor: getPermissionStatus(user.menuList, 'MENU-003') ? '#f0fdf4' : '#fef2f2',
                padding: '4px 8px',
                borderRadius: '6px',
                border: '1px solid',
                borderColor: getPermissionStatus(user.menuList, 'MENU-003') ? '#86efac' : '#fecaca',
              }}>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    fontWeight: 600,
                    color: getPermissionStatus(user.menuList, 'MENU-003') ? '#15803d' : '#dc2626',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <span>Users</span>
                  {getPermissionStatus(user.menuList, 'MENU-003') ? (
                    <CheckCircleIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <CloseIcon sx={{ fontSize: 16 }} />
                  )}
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </TableCell>
        {/* Add this cell before the Created Date cell */}
        <TableCell>
          <Chip 
            label={user.userStatus || 'Inactive'}
            size="small"
            sx={{
              bgcolor: user.userStatus === 'Active' ? '#f0fdf4' : '#fef2f2',
              color: user.userStatus === 'Active' ? '#15803d' : '#dc2626',
              fontWeight: 500,
              textTransform: 'capitalize'
            }}
          />
        </TableCell>
        <TableCell>
          <Typography variant="body2" color="text.secondary">
            {format(new Date(user.createdAt), 'dd MMM yyyy')}
          </Typography>
        </TableCell>
        <TableCell>
          <IconButton 
            size="small"
            onClick={(e) => handleMenuOpen(e, user)}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  })()}
</TableBody>
          </Table>
        </TableContainer>


        {/* User Actions Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: { 
              width: 200, 
              mt: 1,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              borderRadius: 2,
              py: 1 // Add padding to the menu paper
            }
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          disableRestoreFocus
          keepMounted={false}
        >
          <MenuItem 
            onClick={() => handleEditClick(selectedUser)}
            sx={{ 
              py: 1.5,
              px: 2,
              '&:hover': { bgcolor: '#f8fafc' }
            }}
          >
            <EditIcon sx={{ mr: 1.5, fontSize: 20, color: '#3b82f6' }} />
            Edit User
          </MenuItem>
          <MenuItem 
            onClick={() => handleResetPasswordClick(selectedUser)}
            sx={{ 
              py: 1.5,
              px: 2,
              '&:hover': { bgcolor: '#f8fafc' }
            }}
          >
            <LockResetIcon sx={{ mr: 1.5, fontSize: 20, color: '#6366f1' }} />
            Reset Password
          </MenuItem>
          {selectedUser?.roleName !== 'Admin' && (
            <>
              <MenuItem 
                onClick={() => handleStatusChange(selectedUser)}
                sx={{ 
                  py: 1.5,
                  px: 2,
                  '&:hover': { bgcolor: '#fff1f2' }
                }}
              >
                <BlockIcon sx={{ mr: 1.5, fontSize: 20, color: '#dc2626' }} />
                {selectedUser?.userStatus === 'Active' ? 'Deactivate' : 'Activate'} User
              </MenuItem>
            </>
          )}
        </Menu>

        {/* Add User Dialog */}
        <AddUserDialog 
          open={openDialog}
          onClose={handleDialogClose}
          onSuccess={handleAddUserSuccess}
        />

        {/* Edit User Dialog */}
        <EditUserDialog 
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          onSuccess={handleEditSuccess}
          userData={selectedUserData}
        />

        {/* Reset Password Dialog */}
        <ResetPasswordDialog 
          open={openResetDialog}
          onClose={() => {
            setOpenResetDialog(false);
            setSelectedUser(null); // Clear selected user when closing
          }}
          onSuccess={(userName) => {
            handleResetSuccess(userName);
            setOpenResetDialog(false);
            setSelectedUser(null); // Clear selected user after success
          }}
          userData={selectedUser} // Make sure selectedUser contains the full user object
        />

        {/* Confirmation Dialog for status change */}
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            setOpenConfirmDialog(false);
            setStatusChangeUser(null);
          }}
          PaperProps={{
            sx: {
              borderRadius: 2,
              boxShadow: '0 24px 48px -12px rgba(0,0,0,0.18)',
            }
          }}
        >
          <Box sx={{ 
            background: statusChangeUser?.userStatus === 'Active' ? '#dc2626' : '#059669',
            pt: 3, 
            pb: 4,
            px: 3,
            position: 'relative',
            overflow: 'hidden'
          }}>
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: 'radial-gradient(circle at 20% 120%, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 50%)',
            }} />
            <Typography variant="h5" sx={{ 
              color: 'white',
              fontWeight: 700,
              position: 'relative',
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <BlockIcon />
              {statusChangeUser?.userStatus === 'Active' ? 'Deactivate' : 'Activate'} User
            </Typography>
            <Typography variant="body2" sx={{ 
              color: alpha('#fff', 0.7),
              position: 'relative'
            }}>
              Are you sure you want to {statusChangeUser?.userStatus === 'Active' ? 'deactivate' : 'activate'} {statusChangeUser?.staffFullName}?
            </Typography>
          </Box>

          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button 
              onClick={() => {
                setOpenConfirmDialog(false);
                setStatusChangeUser(null);
              }}
              disabled={isStatusUpdating}
              sx={{ 
                color: '#64748b',
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleStatusChangeConfirm}
              disabled={isStatusUpdating}
              sx={{
                bgcolor: statusChangeUser?.userStatus === 'Active' ? '#dc2626' : '#059669',
                '&:hover': { 
                  bgcolor: statusChangeUser?.userStatus === 'Active' ? '#b91c1c' : '#047857'
                },
                minWidth: 100
              }}
            >
              {isStatusUpdating ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={16} color="inherit" />
                  <span>Updating...</span>
                </Box>
              ) : (
                statusChangeUser?.userStatus === 'Active' ? 'Deactivate' : 'Activate'
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              '& .MuiAlert-icon': {
                fontSize: 24
              },
              '& .MuiAlert-message': {
                fontSize: '0.95rem'
              }
            }}
            iconMapping={{
              success: <CheckCircleIcon fontSize="inherit" />
            }}
          >
            {snackbar.message}
          </MuiAlert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default Users;